<template>
  <div v-if="visible" class="app-main-inner">
    <el-form
      :disabled="readonly"
      class="section"
      style="flex-direction: row"
    >
      <el-checkbox v-model="form.booking" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.WhetherDeclarations') }}</el-checkbox>
      <el-checkbox
        v-model="form.insure"
        no="isInsure"
        style="margin-left: -20px;"
      >{{ $t('SeaExport.InsureInfo') }}
      </el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.batch" no="batch" style="margin-left: -20px">{{ $t('SeaExport.InBatchesOrNot') }}</el-checkbox>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;" @change="syncSlaves('destinationPortService')">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <div style="width: fit-content;">
      <div style="display: flex">
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="120px" label-position="right">
            <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input :value="form.jobNo" :disabled="true" />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaSea : p.seaExportEnabled
                  }"
                  :default-value="this.form.saleProductCode || ''"
                  @parentCallBack="p => {this.form.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="this.form.fullOrInside || ''"
                  @parentCallBack="p => {this.form.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <template v-if="form.containerLoadType===BC_CARGO_TYPE.code">
              <el-form-item :label="$t('SeaExport.ConsignationCompany')">
                <cargo-sales-company-select
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :check-credit="true"
                  :default-value="form.customerId||''"
                  :job="form"
                  @parentCallBack="customerIdChange"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomerProperty')">
                <el-tooltip :content="customerTip" placement="bottom">
                  <span
                    v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                    class="orange"
                  >LV{{ customerLevel.level }}</span>
                  <span
                    v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                    style="color:#D3A73B"
                  >&nbsp;{{ customerLevel.customerName }}</span>
                  <span
                    v-show="contractStatusLabel"
                    class="red"
                  >&nbsp;({{ contractStatusLabel }})</span>
                  <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                </el-tooltip>
              </el-form-item>
              <el-form-item
                :label="$t('SeaExport.ContactPerson')"
              >
                <div style="display: flex">
                  <el-select
                    v-model="form.customerContact"
                    no="customerContact"
                    filterable
                    :allow-create="true"
                  >
                    <el-option
                      v-for="(item,index) in contactList"
                      :key="index"
                      :label="item.contactPerson"
                      :value="item.contactPerson"
                    />
                  </el-select>&nbsp;
                  <el-link
                    v-show="!isShowContactPersonDetail"
                    no="customerContactLink"
                    :class="form.customerContact?'':'not-click'"
                    @click="showContactDialog"
                  >{{ $t('SeaExport.Detail') }}
                  </el-link>
                </div>
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.FLCLType')">
              <el-select v-model="form.containerLoadType" no="containerLoadType" @change="pm.selectDefaultCutomJobType();pm.containerLoadTypeChange()">
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingDate')">
              <el-date-picker
                v-model="form.bookingDate"
                no="bookingDate"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex: 1;margin-right: 5px"
                  :disabled="!isJydEditJobFields"
                  @input="etdChange"
                />
                <span>{{ form.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  no="eta"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="etaChange"
                />
                <span>{{ form.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  :value="form.atd"
                  no="atd"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  no="ata"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker v-model="form.customsDate" :disabled="!isJydUpdateCustomsDate" no="customsDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.loadingPortCode"
                  tag-name="englishName"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="width:128px;"
                  @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler()}"
                />&nbsp;
                <el-checkbox v-model="form.transfering" no="transfering" style="padding-left:2px;" @change="pm.updateSecondVesselInfo()">{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item v-show="form.transfering" :label="$t('SeaExport.TransitPort')">
              <cargo-advance-select
                no="transferPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.transferPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"

                @parentCallBack="p=>{form.transferPortCode=p.value;pm.updateSecondVesselInfo()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"

                @parentCallBack="p=>{pm.dischargingPortCodeChange(p, form.carrierId);pm.cargoDocChangeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                class="port-of-delivery-selector"
                popper-class="port-of-delivery-selector-popper"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"

                @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
              <cargo-advance-select
                no="placeOfDeliveryRegion"
                :select-type="selectTypeNames.basic_data_Region"
                filterable
                :default-value="form.placeOfDeliveryRegion"
                @parentCallBack="p=>{form.placeOfDeliveryRegion=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.TransshipmentTransportationMethod') }}</span>
              <cargo-advance-select
                no="transportationMode"
                :static-options="transportationModeInfos"
                :filter-tag-names="['chineseName', 'englishName', 'code']"
                filterable
                :tag-name="'englishName'"
                :default-value="form.transshipmentTransportationModeCode"
                @parentCallBack="p=>{form.transshipmentTransportationModeCode=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible">
              <span slot="label" class="blue">{{ $t('SeaExport.BookingAgent') }}</span>
              <cargo-company-select
                v-if="!isJoinCarrierBookingAgent||form.containerLoadType==='BB'"
                no="bookingAgent"
                class="booking-agent-selector"
                popper-class="booking-agent-selector-popper"
                :disabled="!bookingAgentEnabled"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="form.bookingAgent||''"
                :placeholder="$t('SeaExport.RequiredItem')"

                @change="p=>{pm.bookingAgentChange(p)}"
              />
              <cargo-advance-select
                v-if="isJoinCarrierBookingAgent&&form.containerLoadType!=='BB'"
                no="bookingAgent"
                class="booking-agent-selector"
                popper-class="booking-agent-selector-popper"
                :disabled="!bookingAgentEnabled"
                :select-type="selectTypeNames.static_data_Company"
                :cache="false"
                filterable
                :default-value="form.bookingAgent||''"
                :static-options="bookingAgentList"
                :placeholder="$t('SeaExport.RequiredItem')"

                @parentCallBack="p=>{pm.bookingAgentChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CarrierAgent')">
              <cargo-company-select
                no="carrierAgentId"
                :method-params="{seaCmpAgent:true,active:true}"
                :default-value="form.carrierAgentId||''"

                @change="p=>{form.carrierAgentId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalCompany')">
              <cargo-company-select
                no="terminalCompany"
                :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
                :default-value="form.terminalCompany||''"
                style="width: 100%"
                @change="p=>{JobUtils.terminalCompanyChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-company-select
                ref="shippingCompany"
                no="carrierId"
                :disabled="!carrierIdEnabled"
                :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                :default-value="form.carrierId||''"
                @change="p=>{pm.carrierChangeHandler(p);}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <div style="display: flex; justify-content: space-between">
                <el-select
                  v-model="form.cargoSource"
                  no="cargoSource"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  :clearable="false"
                  size="mini"
                  @change="form.designationAgent=0;pm.cargoSourceChange()"
                >
                  <el-option
                    v-for="(item,index) in CARGO_SOURCES"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>&nbsp;
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                :default-value="form.customJobType"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="form.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <cargo-company-select
                :method-params="{localAgent:true,active: true}"
                :default-value="form.loadingAgentId||''"
                no="loadingAgentId"
                :disabled="readonly"
                :data-filter-function="JobUtils.loadingAgentIdFilter"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                @change="p=>{form.loadingAgentId = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.destinationAgent')">
              <el-tooltip :content="destinationAgentTip" :disabled="!showDestinationAgentWarning" placement="right-end">
                <cargo-company-select
                  ref="destinationAgent"
                  no="destinationAgent"
                  :method-params="{overseaAgent:true,active:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"

                  @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-show="form.cargoSource==='NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <el-tooltip :content="designationAgentTip" :disabled="!showDesignationAgentWarning" placement="right-end">
                <cargo-company-select
                  no="designationAgent"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,active:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"

                  @change="p=>{pm.txtDesignationAgentChangeHandler(p)}"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="exChangeAgent"
                :disabled="!form.dischargingPortDoor"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="form.exChangeAgent||''"
                @change="onExChangeAgentChange"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="form.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="form.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.statisticArea=item.value"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.ServiceChannel')">
              <el-input v-model="fbaJob.serviceChannel" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="140px" label-position="right">
            <span class="title">{{ $t('SeaExport.AdditionalInformation') }}</span>
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-checkbox
                v-model="form.warehousing"
                no="warehousing"
                style="display: block;"
                @change="pm.loadingTermChange('warehousing')"
              >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
              <el-checkbox
                v-model="form.landTransportation"
                no="landTransportation"
                style="display: block;"
                @change="pm.loadingTermChange('landTransportation')"
              >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
              <el-checkbox
                v-model="form.selfDeliver"
                no="selfDeliver"
                style="display: block;"
              >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
              <el-checkbox v-model="form.backUpWarehouse" no="backUpWarehouse" @change="pm.backUpWarehouseChange()">{{ $t('SeaExport.BackUpWarehouse') }} </el-checkbox>
            </el-form-item>
            <el-form-item v-if="isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="form.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
                @change="syncSlaves('dischargingPortDoor')"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
                @change="syncSlaves('usCustomsClearance')"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.destPortCustomsClearance"
                no="destPortCustomsClearance"
                style="display: block;"
                @change="syncSlaves('destPortCustomsClearance')"
              >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item
              id="customerRefNo"
              :label="$t('SeaExport.BusinessReferenceNo')"
            >
              <el-tooltip
                :disabled="!customerRefNoTip"
                :content="customerRefNoTip"
                placement="right-end"
              >
                <el-input
                  v-model="form.customerRefNo"
                  no="customerRefNo"
                  :class="customerRefNoTip?'red':''"
                  @blur="pm.customerRefNoFocusOutHandler()"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="form.cargoSource === 'NC'" id="agentRefNo" :label="$t('SeaExport.NCReferenceNo')">
              <el-input v-model="form.agentRefNo" no="agentRefNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-model="form.poNo" no="poNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :default-value="form.freightTerm"

                @parentCallBack="p=>{form.freightTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="form.paymentTermMBL"

                @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-company-select
                no="customsBroker"
                :disabled="!customsBrokerEnabled"
                :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
                :default-value="form.customsBroker||''"
                :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"

                :data-filter-function="customsBrokerFilter"
                @change="p=>{pm.customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="form.customClaim"
                @parentCallBack="p=>{form.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.ClearanceMethod')">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :default-value="form.tradeTerm"

                @parentCallBack="p=>{form.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                no="carryingCmp"
                :disabled="!form.landTransportation"
                :method-params="{truckCmp:true,active:true}"
                :default-value="form.carryingCmp||''"
                :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"

                @change="p=>{pm.carryingCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.EstimatedStorageReadyGoodsTime')">
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="isFba ? $t('SeaExport.DomesticWarehouse') : (openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse'))">
              <cargo-company-select
                no="warehouseCmp"
                :disabled="!warehouseEabled"
                :method-params="{warehouse:true,active:true}"
                :default-value="form.warehouseCmp||''"
                :placeholder="$t('SeaExport.PleaseSelectWarehouse')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse && !isFba" :label="$t('SeaExport.WareHouseName')">
              <el-select
                ref="warehouseName"
                v-model="form.warehouseName"
                no="warehouseName"
                :disabled="!warehouseEabled||!form.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BackUpWarehouse')">
              <cargo-advance-select
                no="backUpWarehouseCmp"
                :select-type="selectTypeNames.basic_data_Company"
                :cache="false"
                :disabled="!backUpWarehouseEnabled"
                :default-value="form.backUpWarehouseCmp||''"
                filterable
                :static-options="backUpWarehouseCompanyList"
                :placeholder="!backUpWarehouseEnabled? $t('SeaExport.PleaseSelectBackUpWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{pm.backUpWarehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.ForeignWarehouse')">
              <cargo-advance-select
                no="overseaWarehouseCode"
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                filterable
                :method-params="{ifFba:false}"
                :clearable="false"
                tag-name="chineseName"
                :default-value="form.overseaWarehouseCode"
                style="width:100%;"
                @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContractRateProperty')">
              <el-select
                v-model="form.bookingTerm"
                no="bookingTerm"
                :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
                clearable
                size="mini"
              >
                <el-option
                  v-for="(item,index) in bookingTerms"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                :default-value="form.incoTerm"

                @parentCallBack="p=>{form.incoTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehousingInfo')">
              <el-input
                :disabled="true"
                type="textarea"
                :rows="2"
                :value="txtWhs"
                :placeholder="$t('Message.NoStorageInfo')"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="2"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <div style="display: flex;justify-content: space-around">
              <el-checkbox
                v-model="form.allocation"
                no="allocation"
                style="margin: 0"
              >{{ 'Allocation' }}
              </el-checkbox>
              <el-checkbox
                v-model="form.availableCabinSpace"
                no="availableCabinSpace"
              >{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}
              </el-checkbox>
            </div>
          </el-form>
        </div>
        <div :class="'section form-column ' + $selectByLang('form-item-label', 'form-item-label', 'form-item-label-ja')">
          <el-form :disabled="readonly" :label-width="$selectByLang('145px', '', '170px')" label-position="right">
            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <booking-sea-eq-data-grid
              no="seaEqList"
              :value="seaEqList"
              :container-load-type="form.containerLoadType"
              :is-edit="isEdit"
              :job="form"
              style="width:100%"
              @cellChange="()=>{pm.dgSeaEqItemEditEndHandler()}"
              @eqQuantityChange="eqQuantityChangeHandler"
            />
            <el-form-item :label="$t('SeaExport.QuantityConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="SEUtils.changeQWCRule(()=>{form.quantityActual=form.quantityContract});pm.txtPackingChangeHandler()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  v-model="form.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual})"
                />
                <span>PCS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WeightConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="weightContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="weightActualChange"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CubageConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :disabled="!cubageActualEnabled || !isJydEditJobFields"
                  :min="0"
                  @change="cubageContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="cubageActualChange"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item v-if="isFba" label-width="0">
              <div style="display: flex;justify-content: space-around;margin-left: -50px;">
                <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;">{{ $t('SeaExport.WithElectricity') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;">{{ $t('SeaExport.WithMagnetism') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;">{{ $t('SeaExport.Powder') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;">{{ $t('SeaExport.Liquid') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                ref="packing"
                no="packing"
                :default-value="form.packing"
                style="width:100%;"
                @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div style="display: flex">
                <el-input-number
                  no="chargeWeight"
                  :value="form.chargeWeight||undefined"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex:1"
                  @input="val=>{form.chargeWeight=val;context.reloadCharge = true}"
                />&nbsp;
                <span>{{ isFba ? 'KGS' : 'M/T' }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="MergingTickets"
                  type="primary"
                  @click="pm.mergeLclCargoDocInfo('cargoChineseName', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <el-input
                v-model="form.cargoChineseName"
                type="textarea"
                :rows="3"
                no="cargoChineseName"
                :class="form.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.EnglishDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  type="primary"
                  no="EnglishDescriptionOfGoods"
                  @click="pm.mergeLclCargoDocInfo('cargoEnglishName', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <el-input
                  v-model="form.cargoEnglishName"
                  no="cargoEnglishName"
                  type="textarea"
                  :rows="3"
                  :class="form.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                  @input="handleInputCargoEnglishName"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.Marks') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="Marks"
                  type="primary"
                  @click="pm.mergeLclCargoDocInfo('mark', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <special-character-tip :texts="specialCharCheck.mark">
                <el-input
                  v-model="form.mark"
                  no="mark"
                  type="textarea"
                  :rows="3"
                  @input="handleInputMark"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')" class="custom">
              <cargo-advance-select
                no="cargoCode"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                :disabled="readonly"
                filterable
                :clearable="true"
                :default-value="form.cargoCode"
                :allow-create="false"
                @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.cargoName" no="cargoName" :disabled="!(isEdit && form.cargoCode!='' && form.cargoCode!=null)" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="135px" label-position="right">
            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input :value="form.salesChannel" :disabled="true" />
            </el-form-item>
            <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input :value="form.channelNo" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input :value="form.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input :value="form.relatedJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input :value="txtSalesOffice" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Sales')">
              <cargo-user-select
                ref="sales"
                no="sales"
                :disbled="!pm.canChangeSalesOfJob||pm.isWithinCloseAccountDate"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="form.sales||''"
                :merge-load="true"
                @change="p=>{pm.txtSalesChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="form.cargoSalesId||''"
                :merge-load="true"
                :static-options="cargoSalesList"
                @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesDepartment')">
              <cargo-department-new-select
                no="salesOffice"
                :disabled="!form.sales"
                :enables="true"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :department-id="Number(form.salesDepartment)"

                @change="p=>{form.salesDepartment=p.value;pm.departmentChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="opOffice"
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                :office-id="Number(form.opOffice)"
                @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="opDepartment"
                :disabled="pm.isWithinCloseAccountDate"
                :office-id="Number(form.opOffice)"
                :enables="true"
                :department-id="Number(form.opDepartment)"

                @change="p=>{form.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                ref="op"
                no="op"
                :disabled="!opEabled"
                :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                :default-value="form.op||''"
                :merge-load="true"
                :static-options="userPortRoleData.op"
                @change="p=>{pm.txtOPChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csr"
                :method-params="{officeId:pm.isEntrustOrder||fom.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                :default-value="form.csr||''"
                :merge-load="true"
                :static-options="userPortRoleData.csr"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                no="overseaOp"
                :default-value="form.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaOpList)"
                :merge-load="true"
                @change="p=>{pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                no="dc"
                :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                :default-value="form.dc||''"
                :merge-load="true"
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="planner"
                :method-params="{category:'role',shape:'sealine'}"
                :default-value="form.planner||''"
                :merge-load="true"
                :static-options="userPortRoleData.seaLine"
                @change="p=>{pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="form.userDefinedRoleId2||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">
            <span class="title">{{ $t('SeaExport.UserDefinedArea') }}</span>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="form.userDefinedField1"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),form.userDefinedField1,val=>{form.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="form.userDefinedField2"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),form.userDefinedField2,val=>{form.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="form.userDefinedField3"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),form.userDefinedField3,val=>{form.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="form.userDefinedField4"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),form.userDefinedField4,val=>{form.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section" style="width: 100%;">
        <div class="title">
          {{ $t('SeaExport.TicketsInfo') }}
          <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
            <div class="line" style="margin-top:2px" />
            <div class="line" />
          </div>
        </div>
        <div style="display:flex;flex-direction:column;margin-bottom: 5px;line-height: 28px;">
          <div style="padding:5px 0">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ form.lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" style="display: inline-flex;">
              <el-button
                no="NewTickets"
                :disabled="!isSeaExport || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                no="EditTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                no="AddTickets"
                :disabled="!isSeaExport || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                no="RemoveTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="pm.btnRemoveBatchClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                v-permission="['button_fmBookingNew_deleteSmallTicket']"
                no="DeleteTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div ref="slaveDiv" style="display: flex;">
            <cargo-ag-grid
              config-module="130125"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ticketDialog"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="ticketDialogConfirm" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="ticketDialogCancel" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ContactPerson"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="advanceTextDialogConfirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabBookingMasterPM } from './tabBookingMasterPM'
import URL from '@/api/urlTranslator'
import { validateDelJob } from '@/api/seaExport/seaExportJob'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import querySeLclDialog from '@/components/Cargo/Job/querySELclDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ErrorTip } from '@/utils/class/ErrorTip'
import ColumnUtils from '@/utils/ColumnUtils'
import { CONTAINERLOAD_TYPES_LCL, BC_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import {
  CARGO_SOURCES,
  EXPORT_CONTROLLED_PRODUCT,
  LOG_SE_SEA_BOOKING,
  RATE_TYPE,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import lang from '@/lang'
import { getLoading } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import checkPermission from '@/utils/permission'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { dateCompare, multiply, mergeArray, dateCompareYMD } from '@/utils/commonUtil'
import selectData from '@/utils/selectData'
import { FbaJob } from '@/class/model/booking/FbaJob'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { DocumentManage } from '@/utils/commonUtil'
import { checkPoNoIsExist } from '@/api/booking/job'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabBookingMaster',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    CargoRichTextarea,
    cargoAdvanceSelect, bookingSeaEqDataGrid, cargoDepartmentNewSelect, cargoDepartmentSelect,
    cargoUserSelect, cargoCompanySelect, cargoPackingSelect, querySeLclDialog, cargoOfficeSelect,
    AutoNumberInput, specialCharacterTip, CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    isSeaExport: { // 是否为海出页面
      type: Boolean,
      default: false
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    isFba: { // 是否是FBA业务
      type: Boolean,
      default: false
    },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    }
  },
  data() {
    const form = new SeaExportJob().fillDefaultValue().getData()
    form.seaEQ = []
    form.lclSlaves = []
    return {
      customerRefNoTip: '', // 业务参考号鼠标悬浮提示
      jobData: {},
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabBookingMasterPM(this),
      SEUtils,
      URL,
      selectTypeNames: TYPE_NAMES,
      containerLoadTypes: CONTAINERLOAD_TYPES_LCL,
      BC_CARGO_TYPE,
      CARGO_SOURCES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      rateType: RATE_TYPE,
      bookingTerms: BOOKING_TERMS,
      partnerManagementMode: 0,
      isHC: false,
      isJoinCarrierBookingAgent: false, // 船公司和订舱代理关联
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      showDestinationAgentWarning: false,
      destinationAgentTip: '',
      showDesignationAgentWarning: false,
      designationAgentTip: '',
      form,
      bookingAgentList: [],
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null
      },
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatus: 0,
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      txtWhs: '', // 入库信息
      txtSalesOffice: '', // 销售所在分公司
      overseaOpList: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        onCellDoubleClicked: event => {
          this.btnLcLEditClickHandler(event)
        },
        context: {
          componentParent: this
        }
      },
      gridApi: null,
      selectedRowIndex: -1,
      selectedRows: [],
      seaEqList: [],
      ticketDialog: {
        visible: false,
        value: 0
      },
      contactDialog: {
        visible: false,
        data: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        formatObj: {
          autoUppercase: true
        }
      },
      querySELclDialog: {
        visible: false
      },
      backUpWarehouseCompanyList: [], // 合作伙伴类型为仓库，并且仓库类型为前置仓的有效数据
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      openWarehouse: false,
      salesCanSeeBookingAgent: false,
      warehouseNameList: [],
      opEabled: false,
      JobUtils,
      divisionEnabled: false,
      divisionHeight: 10,
      doc: new DocumentManage(),
      poNoRed: false,
      needConfirmProjectNo: false,
      creditOpen: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      transportationModeInfos: [],
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 是否为海运订舱极速版页面
    isBookingNew() {
      return this.$route.path.toLowerCase() === '/SeaExport/BookingNew'.toLowerCase() || this.$route.path.toLowerCase() === '/FBA/FBABookingNew'.toLowerCase()
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look' || (this.action !== 'look' && !!this.form.uuid && !checkPermission(['tab_SEBooking_EditBookingTab']))
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditBookingTab'])))
    },
    bookingAgentEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'bookingAgent') &&
        (this.isJoinCarrierBookingAgent ? this.form.carrierId > 0 : true)
    },
    carrierIdEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'carrierId')
    },
    designationAgentEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'designationAgent')
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!this.form.warehousing) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'WCB')
    },
    officeList() {
      return this.context.officeList
    },
    config() {
      return this.context.config
    },
    rowData() {
      return this.form.lclSlaves || []
    },
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.form.salesChannel)
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.$store.state.tagsView.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    backUpWarehouseEnabled() {
      if (!this.form.backUpWarehouse) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'backUpWarehouse')) {
        return false
      }
      return true
    },
    columnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          colId: 'soNo',
          field: 'soNo',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.Mbl'),
          colId: 'mbl',
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('SeaExport.HouseBillOfLading'),
          colId: 'hblNo',
          field: 'hblNo',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          width: 140,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.Etd'),
          colId: 'etd',
          field: 'etd',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          colId: 'cargoChineseName',
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          colId: 'quantityActual',
          field: 'quantityActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          colId: 'weightActual',
          field: 'weightActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          colId: 'cubageActual',
          field: 'cubageActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          colId: 'chargeWeight',
          field: 'chargeWeight',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          colId: 'shipperLine1',
          field: 'shipperLine1',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('FbaJob.AmazonWarehouseCode'),
          colId: 'fbaWarehouseCode',
          field: 'fbaWarehouseCode',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ExpectedAmazonWarehouseEntryTime'),
          colId: 'fbaPreAmazonWhTime',
          field: 'fbaPreAmazonWhTime',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
          colId: 'quantityContract',
          field: 'quantityContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
          colId: 'weightContract',
          field: 'weightContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
          colId: 'cubageContract',
          field: 'cubageContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.FinalDestination'),
          hide: true,
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 150
        }
      ]
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    divisionHalfHeight() {
      return this.divisionHeight / 2
    },
    location() {
      if (!this.form.fba) {
        return LOG_SE_SEA_BOOKING.code
      }
      return ''
    },
    isCopy() {
      return this.action === 'copy'
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.form.uuid)
    },
    isJydUpdateCustomsDate() { // 集翊达判断有编辑操作日期权限，不是则默认可以编辑
      return this.isJyd ? this.$checkPermission(['role_SEBooking_UpdateCustomsDate']) : true
    }
  },
  watch: {
    // 已订阅过货物计费项目时，修改了船公司则弹窗提醒
    'form.carrierId': {
      handler(newValue, oldValue) {
        this.jobData = new SeaExportJob(this.form)
        const goodsTracking = [
          'realArrivalsDate', 'estimatedArrivalTime', 'actualArrivalTime', 'estimatedPortDischargeTime', 'portDischargeTime',
          'estimatedRailwayDepartureTime', 'railwayDepartureTime', 'estimatedRailwayDischargeTime',
          'railwayDischargeTime', 'estimatedArrivalPlaceOfDelivery', 'actualArrivalPlaceOfDelivery', 'estimatedCustomsReleaseTime',
          'destPortCustomsClearanceTime', 'destPortInspection', 'destPortInspectionLevel', 'estimatedPickUpTime', 'actualPickUpTime', 'estimatedReturnTime', 'destPortReturnTime',
          'secondArrivalsDate', 'secondUnloadingDate', 'secondLoadingDate', 'secondShipmentDate', 'bargeETD', 'bargeETA']
        if (this.carrierIdEnabled && oldValue && this.isEdit && this.isWriteback(goodsTracking)) {
          if (newValue) {
            this.$confirm(this.$t('SeaExport.ShippingCompanyDialogModifyText'), this.$t('SeaExport.tip'), {
              confirmButtonText: this.$t('SeaExport.emptyDestinationInformation'),
              cancelButtonText: this.$t('SeaExport.noEmptyDestinationInformation'),
              type: 'info'
            }).then(() => {
              this.clearPortDestination(goodsTracking)
            }).catch(() => {})
          } else {
            this.$confirm(this.$t('SeaExport.ShippingCompanyDialogDeleteText'), this.$t('SeaExport.tip'), {
              confirmButtonText: this.$t('SeaExport.emptyDestinationInformation'),
              cancelButtonText: this.$t('SeaExport.noEmptyDestinationInformation'),
              type: 'info'
            }).then(() => {
              this.clearPortDestination(goodsTracking)
            }).catch(() => {})
          }
        }
      }
    }
  },
  created() {
    // await this.context.prepareData()
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.isShowContactPersonDetail = String(this.config.get('ToExoSystem')) === 'HC'
    this.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.pm.init()
    console.log('==========>>>>form', this.form)
    this.visible = true
  },
  mounted() {
    this.doc.set('dragging', e => {
      if (!this.divisionEnabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', () => {
      document.getElementById('app').classList.remove('disabled-select')
      this.divisionEnabled = false
    })
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    this.doc.destory()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (this.isEdit) {
        if (this.form.uuid) {
          this.opEabled = await SecurityUtil.canEdit(this.form, false)
        } else {
          this.opEabled = true
        }
      }
      // console.log('isRefresh==========', isRefresh, 'row.seaEQ====', row.seaEQ)
      if (!isRefresh) {
        this.pm.formInitialValue = { ...this.form }
        return
      }
      this.openWarehouse = Number(this.config.get('isOpenWarehouse')) > 0
      this.salesCanSeeBookingAgent = Number(this.config.get('SalesCanSeeBookingAgent')) === 1
      if (!row.uuid) {
        const jobModel = new SeaExportJob(row)
        jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
        if (jobModel.seaCargoDoc.findIndex(p => p.docType === 'MBL') === -1) {
          const mdoc = await jobModel.getCargoDocByType('MBL', true)
          jobModel.seaCargoDoc.push(mdoc)
        }
      }
      row.atdChanged = false
      row.ataChanged = false
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.form = row
      console.log('row================', row)
      this.checkSpecialCharacter()
      this.seaEqList = this.form.seaEQ || []

      this.pm.changeJob()
      this.pm.fillView()
      if (this.isEdit) {
        this.pm.checkValueMatch()
      }
      this.setSecondaryCustomJobTypeFunc()
      this.setCustomJobTypeFunc()
      JobUtils.setSailingDay(this.form)
      // console.log('form.seaEQ====', this.form, this.form.seaEQ, this.form.lclSlaves)
      // CARGO-32385 主票页面时没有加载委托单位对应联系人
      if (this.form.customerId) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.form.customerId)
        this.contactList = await Company.loadContact(company.uuid)
      }
      // fba
      if (this.form.fba) {
        this.fbaJob = this.form.uuid ? this.form.fbaJob : new FbaJob().fillDefaultValue().getData()
      }
      // CARGO-33935 新增的时候，默认把卸货港代码同步到订舱页面
      if (this.action === 'add' && this.pm.sEUseDischargingPort5Code) {
        this.pm.refreshPortCode(this.form.dischargingPortCode, this.form.carrierId)
      }
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo && !this.isEdit) {
        checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => { this.poNoRed = (res.data > 0) })
      }
      JobUtils.getReceiptCharges(this.form)
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness)
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    handleInputCargoEnglishName(value) {
      this.form.cargoEnglishName = this.isUppercaseByConfig ? value.toUpperCase() : value
    },
    handleInputMark(value) {
      this.form.mark = this.isUppercaseByConfig ? value.toUpperCase() : value
    },
    clearPortDestination(goodsTracking) {
      for (const item of goodsTracking) {
        this.jobData[item] = ''
      }
      // if (this.jobData.lclSlaves) {
      //   this.jobData.lclSlaves.forEach((item) => {
      //     for (const value of goodsTracking) {
      //       item[value] = ''
      //     }
      //   })
      // }
    },
    isWriteback(goodsTracking) {
      const arr = []
      for (const item of goodsTracking) {
        if (this.jobData[item]) {
          arr.push(this.jobData[item])
        }
      }
      return arr.length
    },
    checkSpecialCharacter() {
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.form.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.form.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    async getSubmitData() {
      try {
        await this.pm.validateForm()
      } catch (err) {
        throw err
      }
      // 这里太平mbl hasCode用的基本页签的，这里让基本页签过滤下特殊字符
      if (Number(this.config.get('SEHSCodeMode')) === 1) {
        JobUtils.checkSpecialCharacters(this.form, 'hsCode')
      }
      JobUtils.checkSpecialCharacters(this.form, 'remarks')
      const job = { ...this.form }
      // 清空子表数据
      // for (const key in job) {
      //   if (typeof job[key] === 'object') {
      //     job[key] = undefined
      //   }
      // }
      if (this.form.containers) {
        for (const container of this.form.containers) {
          if (container.containerUsage) {
            for (const item of container.containerUsage) {
              if (item.poItems === '') {
                item.poItems = []
              }
              if (!item.ediContainers) {
                delete item.ediContainers
              }
            }
          }
        }
      }
      const mblList = []
      const cargoDocList = await new SeaExportJob(job).getSeaCargoDoc()
      if (cargoDocList && cargoDocList.length > 0) {
        for (const doc of cargoDocList) {
          if (doc.docType && (doc.docType === 'MBL' || doc.docType === 'MBL2')) {
            mblList.push(doc)
          }
        }
      }

      // fba业务
      const fbaJob = this.isFba ? this.fbaJob : null
      return {
        job,
        seaEQ: this.form.seaEQ,
        delseaEQUuids: this.form.delseaEQUuids,
        containers: this.form.containers, // .filter(p => p.isDirty === true),
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids, // 删除的装箱uuid
        seaCargoDoc: mblList,
        fbaJob
      }
    },
    async customerIdChange(company) {
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.form.customerContact = ''
      if (!company.cmpIdx) {
        this.form.customerId = 0
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.form.uuid))
      this.form.customerId = company.cmpIdx
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }
      await this.loadCustomerDetial(company)
      this.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
      const contact = this.getDefaultContact(this.contactList)
      this.form.customerContact = contact ? contact.contactPerson : ''
      this.pm.loadCompanyUserByCargoSource()
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    async loadCustomerDetial(company) {
      let customer = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      if (customer) {
        customer = new Customer(customer)
        const customerType = await customer.getCustomerType()
        if (customerType) {
          this.customerLevel.level = customerType.typeId
          this.customerLevel.customerName = this.isZh ? customerType.chineseName : customerType.englishName
        }
      }
    },
    // 获取合约状态
    getContractStatus(company) {
      if (!company) return
      Company.loadAgreementClientContract(company.uuid).then(async contracts => {
        if (contracts && contracts.length > 0) {
          const now = moment()
          const businessIds = []
          for (const item of contracts) {
            // 过滤出当前合作伙伴所有未到期的合同
            if (dateCompareYMD(item.endDate, now) >= 0) {
              businessIds.push(item.uuid)
            }
          }
          company.contractStatus = businessIds.length > 0 ? 2 : 1
        } else {
          company.contractStatus = 0 // 未签约
        }
        const contractState = selectData.contractStatuses[company.contractStatus]
        this.contractStatus = company.contractStatus
        this.contractStatusLabel = contractState ? contractState.label : ''
        this.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.form))
      })
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    showContactDialog() {
      if (!this.form.customerContact) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.form.customerContact) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    },
    async etdChange(value) {
      await JobUtils.seEtdChange(this, value, this.form, this.context, this.isJyd)
    },
    async etaChange(value) {
      this.form.eta = value
      this.form.etaSailingDay = JobUtils.dateChange(this.form.eta)
    },
    async atdChange(value) {
      const oldValue = this.form.atd
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
      // CARGO-23752 【海运订舱极速版】-HBL 签发日期需要由【基本页签】实际开航日期(ATD)自动带出 主票下的小票数据在后端处理
      const cargoDocList = await new SeaExportJob(this.form).getSeaCargoDoc()
      if (cargoDocList && cargoDocList.length > 0 && parseInt(this.config.get('syncSignDateBl')) === 1) {
        for (const d of cargoDocList) {
          const allow = d.docType && (d.docType === 'MBL' || d.docType === 'MBL2') && d.state < 2 && (!d.signDateBL || (oldValue && dateCompare(d.signDateBL, oldValue) === 0))
          if (allow) {
            d.signDateBL = value
          }
        }
      }
      this.form.atdChanged = true
    },
    async ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
      this.form.ataChanged = true
    },
    syncSlaves(field) {
      for (const slave of this.form.lclSlaves) {
        slave[field] = this.form[field]
        this.pm.addLclSlaveToModifiedSet(slave)
      }
    },
    onExChangeAgentChange(data) {
      this.form.exChangeAgent = data.value
      const operatingJobKeySet = new Set()
      for (const slave of this.form.lclSlaves) {
        if (slave.jobState === 0) {
          if (!this.isJyd) {
            slave.exChangeAgent = data.value
            this.pm.addLclSlaveToModifiedSet(slave)
            operatingJobKeySet.add(slave.uuid)
          }
        }
      }
      for (const item of this.form.dischargingTrucking) {
        if (operatingJobKeySet.has(item.jobUuid)) {
          item.exChangeAgent = data.value
        }
      }
      this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.form, this.form.weightContract)
      }
      await SEUtils.changeQWCRule(async() => {
        if (this.form.weightActual !== this.form.weightContract) {
          this.form.weightActual = this.form.weightContract
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshWeightCharge(this.form, this.form.weightActual)
          }
        }
      })
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      if (job.typeHBL !== BillType.MERGE_BILL_TYPE.code) {
        await ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
      }
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.refreshWeightCharge(this.form, this.form.weightContract)
          }
        }
      })
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      await SEUtils.changeQWCRule(async() => {
        if (this.form.cubageActual !== this.form.cubageContract) {
          this.form.cubageActual = this.form.cubageContract
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshCubageCharge(this.form, this.form.cubageActual)
          }
        }
        this.form.chargeWeight = this.form.cubageContract
      })
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    async cubageActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshCubageCharge(this.form, this.form.cubageActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.cubageContract !== this.form.cubageActual) {
          this.form.cubageContract = this.form.cubageActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.refreshCubageCharge(this.form, this.form.cubageContract)
          }
          this.form.chargeWeight = this.form.cubageActual
        }
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = true, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = { autoUppercase: false }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    // grid多选
    onMultipleSelected(event) {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    /**
     * 拼箱主票直接新增拼箱分票
     */
    async btnCreateClickHandler() {
      const job = this.form
      if (!job.jobNo) {
        throw new ErrorTip(this.$t('Message.TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst'))
      }
      if (!await SecurityUtil.canOPEditWithAlert(job)) {
        return
      }
      this.ticketDialog.value = 1
      this.ticketDialog.visible = true
    },
    toAddTicket() {
      this.pm.selectWindowHandler(this.ticketDialog.value)
      this.ticketDialog.visible = false
    },
    /**
     * 编辑选择的拼箱分票
     */
    async btnLcLEditClickHandler() {
      if (this.selectedRow) {
        if (this.selectedRow.jobState !== 0) {
          this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
          return
        }
        if (!await SecurityUtil.canOPEditWithAlert(this.selectedRow)) {
          return
        }
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    /**
     * 加入小票
     */
    async btnImportLclClickHandler(event) {
      if (!await SecurityUtil.canOPEditWithAlert(this.form)) {
        return
      }
      this.querySELclDialog.visible = true
    },
    /**
     * 单票删除小票
     */
    async btnRemoveClickHandler() {
      const selectJob = this.selectedRow
      if (!selectJob) {
        throw new ErrorTip(this.$t('Message.PleaseSelectSubBills'))
      }
      if (!this.$checkPermission(['button_fmBookingNew_deleteSmallTicket'])) {
        throw new ErrorTip(this.$t('Message.DeleteSmallTicketTips'))
      }
      if (this.viewJobNoSet.has(selectJob.jobNo)) {
        throw new ErrorTip(this.$t('queryJob.JobOpenedAndCannotDelete'))
      }
      if (selectJob.jobState > 0) {
        throw new ErrorTip(this.$t(`[${selectJob.jobNo}]${this.$t('Message.IsNotOperationStatus')}`))
      }
      await new SeaExportJob(selectJob).getContainerUsages()
      if (selectJob.quantityActual !== this.pm.getItemLeft(selectJob) || selectJob.weightActual !== this.pm.getWeightLeft(selectJob) ||
        selectJob.cubageActual !== this.pm.getCubageLeft(selectJob)) {
        throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
      }
      if (selectJob.containerUsages && selectJob.containerUsages.length > 0) {
        for (const c of selectJob.containerUsages) {
          if (c.container && c.container.jobUuid && c.container.jobUuid === this.form.uuid) {
            throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
          }
        }
      }
      const loading = getLoading()
      this.context.loading = true
      await validateDelJob({ jobKeys: [selectJob.uuid] }).then(res => {
        this.pm.validateDelJobResultHandler(res.data)
      }).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // params.jobuuid = this.form.uuid
      // params.JOB_UUID = this.form.uuid
      // params.REQUEST_UUID = ''
      PrintTemplateUtil.buildPrintDataByBooking(this.form, params)
      params.category = 'BOOKING'
      params.ctx = new SeaExportJob(this.form)
      this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(job, "BOOKING", params, view);
    },
    async endTabHandler() {
      await this.pm.fillModel()
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    eqQuantityChangeHandler() {
      ChargeUtils.eqQuantityChangeHandler(this.form, this.context)
    },
    dragging(e) {
      document.getElementById('app').classList.add('disabled-select')
      const division = this.$refs.division
      const divisionRect = division.getBoundingClientRect()
      const slaveDiv = this.$refs.slaveDiv
      const slaveDivRect = slaveDiv.getBoundingClientRect()
      // 拖拽偏移量（向上增加高度，向下缩减高度） = 拖拽图标位置 - 鼠标位置
      const dragOffset = divisionRect.top + this.divisionHalfHeight - e.clientY
      // 新的小票区域高度
      let newHeight = slaveDivRect.height + dragOffset
      // 表格最小高度为200
      if (newHeight < 200) {
        newHeight = 200
      }
      slaveDiv.style.height = newHeight + 'px'
      // 触发竖向的滚动条滚动
      this.$emit('verticalScroll', dragOffset)
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.form, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), modifiedData: this.context.modifiedData })
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
      JobUtils.opOfficeChange({ view: this, job: this.form, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }) })
      this.form.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.form.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.form.customJobType, this.form.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-item-label {
    .el-form-item {
      /deep/.el-form-item__label {
        width: 105px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 105px !important;
      }
    }
  }
  .form-item-label-ja {
    min-width: 335px;
    .el-form-item {
      /deep/.el-form-item__label {
        width: 130px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 130px !important;
      }
    }
  }
</style>

<style scoped lang="scss" scoped>
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
